export const Logo = ({ href }: { href: string }) => (
  <a href={'https://www.immersivehomes.com'}>
    <img
      style={{
        width: '113px',
        paddingTop: '8px',
      }}
      src={href}
      alt="logo"
    />
  </a>
);
